// extracted by mini-css-extract-plugin
export var card = "_8u-0";
export var expandedCard = "_8u-2";
export var paginated = "_8u-1";